
import { Subject } from 'rxjs';

const subject = new Subject();
const initialState = {
  message: '',
};

let state = initialState;

const sharePermission = {
  subscribe: (setState) => subject.subscribe(setState),
  sendMessage: (message) => {
    state = {
      ...state,
      message: message
    };
    subject.next(state);
  },
  initialState
};
//console.log(state);

export default sharePermission;
